<template>
    <div class="images_banner">
        <swiper ref="swiper" class="pc" :options="options">
            <template v-for="(item, index) in data">
                <swiper-slide :key="index">
                    <div class="group">
                        <template v-for="(_item, _index) in item">
                            <router-link class="item" 
                            v-if="!_item.showMore"
                            :key="_index"
                            :to="`/project/${_item.url}`">
                                <div class="cover" :style="`background-image: url(${_item.image});`"></div>
                                <div class="info">
                                    <div class="title">
                                        <p>{{_item.image_name_en}}</p>
                                        <p>{{_item.image_name}}</p>
                                    </div>
                                    <p class="desc">{{_item.image_desc}}</p>
                                </div>
                            </router-link>
                            <router-link class="item more" v-else :key="_index" :to="`/office#${name}`"><div class="info"></div><div class="text">了解更多&gt;</div></router-link>
                        </template>
                    </div>
                </swiper-slide>
            </template>
        </swiper>
        <swiper ref="mobileSwiper" class="mobile" :options="mobileOptions">
            <template v-for="(item, index) in mobileData">
                <swiper-slide :key="index">
                    <router-link class="item" 
                    v-if="!item.showMore"
                    :key="index"
                    :to="`/project/${item.url}`">
                        <div class="cover" :style="`background-image: url(${item.image});`"></div>
                        <div class="info">
                            <div class="title">
                                <!-- <p>{{item.image_name_en}}</p> -->
                                <p>{{item.image_name}}</p>
                            </div>
                            <p class="desc">{{item.image_desc}}</p>
                        </div>
                    </router-link>
                    <router-link class="item more" v-else :key="index" :to="`/office#${name}`">了解更多&gt;</router-link>
                </swiper-slide>
            </template>
        </swiper>
        <div class="swiper-button-prev pc" slot="button-prev"></div>
        <div class="swiper-button-next pc" slot="button-next"></div>
        <div class="swiper-button-prev mobile" slot="button-prev"></div>
        <div class="swiper-button-next mobile" slot="button-next"></div>
    </div>
</template>

<script>
import { swiper, swiperSlide, directive, navigation } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import lineBreaks from '../utils/lineBreaks';
export default {
    name: "imagesBanner",
    props: [ 'data', 'name', 'mobileData' ],
    data() {
        return {
            options: {
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.images_banner .swiper-button-prev.pc',
                    nextEl: '.images_banner .swiper-button-next.pc',
                },
                observer: true,
                observeParents: true,
                spaceBetween: '1.25%',
            },
            mobileOptions: {
                resistanceRatio: 0,
                navigation: {
                    prevEl: '.images_banner .swiper-button-prev.mobile',
                    nextEl: '.images_banner .swiper-button-next.mobile',
                },
                observer: true,
                observeParents: true,
                autoHeight: true,
            },
        };
    },
    computed: {
        swiper() {
            return this.$refs.swiper.swiper
        },
        mobileSwiper() {
            return this.$refs.mobileSwiper.swiper
        },
        textToHtml: lineBreaks.textToHtml
    },
    components: {
        swiper,
        swiperSlide,
        
    },
    mounted() {
    },
    destroyed() {},
    watch: {
        data(){
            // 数据变动后，轮播图切换到第一个
            this.swiper.slideTo(0, 0);
        },
        mobileData(){
            this.mobileSwiper.slideTo(0, 0);
        }
    },
    methods: {},
};
</script>

<style scoped lang="scss">
.images_banner{
    position: relative;
    .mobile{
        display: none;
    }
    .group{
        display: flex;
        flex-wrap: wrap;
        .item{
            display: block;
            overflow: hidden;
            position: relative;
            height: 2.6rem;
            margin: 0 .15rem .15rem 0;
            color: #fff;
            &:nth-of-type(1){ width: 5.1rem }
            &:nth-of-type(2){ width: 3.05rem }
            &:nth-of-type(3){ width: 3.55rem; margin-right: 0 }
            &:nth-of-type(4){ width: 6.1rem; margin-bottom: 0; }
            &:nth-of-type(5){ width: 5.75rem; margin: 0 }
            &.more{
                // width: 3.55rem;
                background: #5f5f5f;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: .24rem;
                .text{
                    position: relative;
                }
            }
            .cover{
                width: 100%;
                height: 100%;
                background: no-repeat center/cover;
            }
            .info{
                background: rgba($color: #ff4836, $alpha: .9);
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                padding: .1rem 0;
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                opacity: 0;
                visibility: hidden;
                transition: opacity .5s, visibility .5s;
                .title{
                    font-size: .26rem;
                    text-align: center;
                }
                .desc{
                    padding: 0 .6rem;
                }
            }
            &:hover{
                .info{
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
    }
    .swiper-button-prev,
    .swiper-button-next{
        width: .24rem;
        height: .3rem;
        background: no-repeat 0/100%;
        margin-top: -.15rem;
        &::after{
            display: none;
        }
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: -.75rem;
        background-image: url('~@/assets/images/icon_arrow_prev.svg');
    }
    .swiper-button-next{
        right: -.75rem;
        background-image: url('~@/assets/images/icon_arrow_next.svg');
    }
    @media only screen and (max-width: 1200px) {
        .pc{
            display: none;
        }
        .mobile{
            display: block;
            .item{
                width: 100%;
                display: block;
                color: #fff;
                &.more{
                    height: 8.3rem;
                    background: #5f5f5f;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: .6rem;
                }
                .cover{
                    width: 100%;
                    height: 8.3rem;
                    background: no-repeat center/cover;
                }
                .info{
                    background: #ff4836;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-evenly;
                    padding: .6rem 1rem;
                    .title{
                        font-size: .6rem;
                        text-align: center;
                        margin-bottom: .6rem;
                    }
                    .desc{
                        line-height: 1.8;
                        font-size: .36rem;
                    }
                }
            }
        }
        .swiper-button-prev,
        .swiper-button-next{
            width: .64rem;
            height: .82rem;
            top: 4.15rem;
            margin-top: -.41rem;
        }
        .swiper-button-prev{
            left: .35rem;
        }
        .swiper-button-next{
            right: .35rem;
        }
    }
}
</style>